import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {QUERIES, isNotEmpty, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {Embedding, initialEmbeding} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {EmbeddingsListLoading} from '../components/loading/EmbeddingsListLoading'
import {createEmbeddings, deleteEmbedding} from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {PasswordMeterComponent} from '../../../../../../_metronic/assets/ts/components'
import {getAllRoles} from '../../../roles-list/core/_requests'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../../../../_metronic/common/rbac/Can'
import {useAuth} from '../../../../auth'
import {useCompanies} from '../../../../auth/core/Companies'
import {uploadProfile} from '../../../settings/core/_requests'
import {generateEmbeddings} from '../../training-list/core/_requests'
import { toast, ToastContainer } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query'

type Props = {
  isUserLoading: boolean
  id: any
  data: any
}

const EmbeddingsDeleteFile: FC<Props> = ({id, isUserLoading, data}) => {
  const {setItemIdForUpdate, setpasswordUpdateCheck, passwordUpdateCheck} = useListView()
  const {refetch} = useQueryResponse()
  const [roles, setRoles] = useState<string[]>([])
  const auth: any = useAuth()
  const [isuploading, setuploading]: any = useState(false)
  const {defaultCompany} = useCompanies()
  const [selectedFile, setselectedFile]: any = useState(null)
  const [loading, setLoading] = useState(false)
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  const inputStyle = {
    position: 'absolute' as 'absolute',
    opacity: 0,
    height: '100%',
    right: 0,
    top: 0,
  }

  const cancel = (withRefresh?: boolean) => {
    console.log(id)
    let filename: any = data?.filePath ?? ''
    console.log(filename)
    console.log(defaultCompany?.company_id)
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
    setpasswordUpdateCheck(false)
  }

  const activate = async () => {
    if(passwordUpdateCheck){
      updateStatus.mutateAsync()
    }
    else{
      let apiData = {
        csv_link:  data?.filePath,
        company_name: defaultCompany?.company_id,
        id: id,
      }
      setLoading(true)
      var response: any = await generateEmbeddings(apiData)
      setLoading(false)
      toast.success(response.message);
      setItemIdForUpdate(undefined)
      setpasswordUpdateCheck(false)
    }
  }

  const updateStatus = useMutation(() => deleteEmbedding(id,defaultCompany?.company_id ?? ''), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      setItemIdForUpdate(undefined)
      setpasswordUpdateCheck(false)
    },
  })

 

 

  return (
    <>
      <label className='required fw-bold fs-6 mb-2'>
        {!passwordUpdateCheck ? 'Are you sure want to activate this embedding file?' : 'Delete Embedding File?'}
      </label>

      <div className='text-center pt-15'>
        <button
          type='reset'
          onClick={() => cancel()}
          className='btn btn-light me-3'
          data-kt-users-modal-action='cancel'
        >
          No
        </button>
        <button type='submit' className='btn btn-primary' onClick={() => activate()}>
          {!loading && 'Yes'}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Actions */}
    </>
  )
}

export {EmbeddingsDeleteFile}
